module.exports = __webpack_public_path__ + "annualreview2017/static/img/cabinet-office@2x.ce0e5a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cabinet-office@2x.png
// module id = 145
// module chunks = 0